import { storeInfo } from "@/api/user";
import { restockStore } from "@/@types/restock";
import { GetWarehouseList, GetShippingType, WarehouseList, ShippingType } from "@/api/Kilimall/restockPlan";
import { GetMapsList } from "@/api/Kilimall/replenishment";
import store from '@/store'
// 公共方法


/**
 * 获取店铺信息,并更新本地数据
 */
const updateStoreInfo = () => {
    storeInfo().then((ret: any) => {
        if (ret.code === 200) {
            store.dispatch("setStoreInfo", ret.data);
        }
    });
}

// 获取计划备货的仓库列表
const getWarehouseList = async (isAdmin: boolean = false, platId) => {
    const warehouseFn = isAdmin ? WarehouseList(platId) : GetWarehouseList(platId)
    const res: any = await warehouseFn;
    if (res.code === 200) {
        store.dispatch("setWarehouse", res.data);
        return res.data
    }
    return null

};
/** 获取计划备货的发货方式  */
const getShippingType = async (isAdmin: boolean = false, platId) => {
    const shippingFn = isAdmin ? ShippingType(platId) : GetShippingType(platId)
    const res: any = await shippingFn;
    if (res.code === 200) {
        const newArr = []
        Object.keys(res.data).forEach((item: any) => {
            newArr.push({ name: res.data[item], code: item });
        });
        store.dispatch("setShipping", newArr);
        return newArr
    }
    return null
};
/** 获取计划备货邀请渠道数据  */
const getMaps = async (platId) => {
    const shippingFn = GetMapsList()
    const res: any = await shippingFn;
    if (res.code === 200) {
        const newArr = []
        store.dispatch("setMaps", res.data);
        return newArr
    }
    return null
};
/**获取计划备货的仓库或者发运方式数据/邀请渠道(平台) */
const setApplyCondition = (type: string | Array<string>, platId:number = 1, isAdmin?: boolean) => {
    return new Promise(async (resolve, reject) => {
        // type 可以为all,warehouse,shipping 
        const warehouse = JSON.parse(
            localStorage.getItem(restockStore.restock_warehouse)
        );
        const shipping = JSON.parse(
            localStorage.getItem(restockStore.restock_shipping)
        );
        const mapsList = JSON.parse(
            localStorage.getItem(restockStore.restock_maps)
        );
        let resData = {
            warehouse: warehouse,
            shipping: shipping,
            mapsList: mapsList,
        }
        let isRequest = false

        /** 1. 仓库列表/发货方式/其他的maps(channel等)无数据重新请求,有数据从缓存中获取数据
         *  2. 传入 string 类型,获取单个的数据("warehouse")或全部数据("all")
         *  3. 传入数组时,分为两种情况:
         *       3.1 不管有无数据时都能重新获取数据,则要传入一个数组,列入想要获取仓库列表 ['getWarehouse']
         *       3.2 同时获取其中的两个或多个 如: ["warehouse","maps"]
         */
        if ((!warehouse?.length && (type === 'warehouse' || type.includes("warehouse") || type === 'all')) || type.includes("getWarehouse")) {
            resData.warehouse = await getWarehouseList(isAdmin, platId)
            isRequest = true
        }
        if ((!shipping?.length && (type === 'shipping' || type.includes("shipping") || type === 'all')) || type.includes("getShipping")) {
            resData.shipping = await getShippingType(isAdmin, platId);
            isRequest = true
        }
        if ((!mapsList && (type === 'maps'|| type.includes("maps")))  || type.includes("getMaps")) {
            resData.mapsList = await getMaps(platId);
            isRequest = true
        }
        !isRequest || resData.warehouse || resData.shipping || resData.mapsList  ? resolve(resData) : reject()
    })

};

/** 处理请求参数 未包含在notInclude 中的数据才可保留 参数进行传递*/
const setParamsObj =(obj,notInclude = ['', null, undefined]) => {
    if (!obj) {
        return
    }
    const newObj = {}
    Object.keys(obj).forEach((item) => {
        const _c = obj[item]
        if (!notInclude.includes(_c)) {
          newObj[item] = _c
        }
    })
    return newObj
}
export {
    updateStoreInfo,
    getWarehouseList,
    getShippingType,
    setApplyCondition,
    setParamsObj
}
